import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
export default function DModalFooter({ className, style, actionPlacement, children, }) {
    const generateClasses = useMemo(() => ({
        'modal-footer': true,
        [`d-modal-action-${actionPlacement}`]: !!actionPlacement,
    }), [actionPlacement]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "d-modal-separator" }), _jsx("div", { className: classNames(generateClasses, className), style: style, children: children })] }));
}
//# sourceMappingURL=DModalFooter.js.map